export const BLOG_POST_COVER_IMAGE_MAX_WIDTH = 600;
export const BLOG_POST_COVER_IMAGE_MAX_HEIGHT = 360;
